import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material';
import {PostHogProvider} from "posthog-js/react";
import './i18n'

declare module '@mui/material/styles' {

  interface Palette {
    customBackground: {
      main: string;
    };
  }

  interface PaletteOptions {
    customBackground?: {
      main?: string;
    };
  }

  interface TypographyVariants {
    navText: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    navText?: React.CSSProperties;
  }

  interface Palette {
    customDrawer: {
      main: string;
      iconColor: string;
      border?: string;
    };
  }

  interface PaletteOptions {
    customDrawer?: {
      main?: string;
      iconColor?: string;
      border?: string;
    };
  }

  interface Palette {
    customAppBar: {
      iconColor: string;
      fontColor: string;
    };
  }

  interface PaletteOptions {
    customAppBar?: {
      iconColor?: string;
      fontColor?: string;
    };
  }

  interface Palette {
    signIn: {
      main: string;
    };
  }

  interface PaletteOptions {
    signIn?: {
      main?: string;
    };
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    navText: true;
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#464E5A',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#cccccc',
    },
    error: {
      main: '#d32f2f',
    },
    background: {
      default: '#F4F6FA',
      paper: '#ffffff',
    },
    customDrawer: {
      main: 'rgba(0, 0, 0, 0)',
      iconColor: '#464E5A',
      border: '1px solid #EEEFF1',
    },
    customBackground: {
      main: '#ffffff',
    },
    customAppBar: {
      iconColor: '#373A40',
      fontColor: '#061e2b',
    },
    action: {
      active: '#3768bd',
    },
    signIn: {
      main: '#F8FF9D'
    }
  },
  typography: {
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji',
    h1: {
      fontSize: '2.25rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 400,
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 400,
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
    },
    navText: {
      fontSize: '0.8rem',
      fontWeight: 400,
      color: '#292929',
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '4px',
        },
        contained: {
          backgroundColor: '#145DA0',
          "&:hover": {
            backgroundColor: "#2E8BC0"
          }
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          margin: '10px 0',
          '& .MuiInputBase-root': {
            backgroundColor: 'transparent',
            borderRadius: '4px',
            paddingTop: '.25rem',
            paddingBottom: '.25rem'
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px',
            borderColor: '#d4d4d4',
            top: 0,
            bottom: 0
          },
          '& .MuiInputLabel-root': {
            color: '#686D76'
          },
          '& .MuiInputBase-input': {
            paddingLeft: '.75rem',
            paddingRight: '.75rem',
            paddingTop: '.625rem',
            paddingBottom: '.625rem'
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: 'outlined' },
              style: {
                borderRadius: '8px',
                boxShadow: 'none',
                backgroundColor: '#F4F6FA',
              }
            }
          ]
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 0,
          paddingBottom: 0,
          '&:last-child': {
            paddingBottom: 0
          }
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        root: {
          marginTop: 0,
          '&.MuiInput-root': {
            marginTop: 0,
          },
          '&:not(:first-of-type)': {
            marginTop: 0,
          },
        },
      },
    }
  },
});

const apiKey = 'phc_erGXNuWhLqONFf8o2CJS8X5Zq9RDCmPD4798UElj6aS';
const apiHost = 'https://eu.i.posthog.com';

if (!apiKey || !apiHost) {
  throw new Error('PostHog API key or host is missing');
}

const options = {
  api_host: apiHost
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ThemeProvider theme={theme}>
    <main className="light text-foreground bg-background">
      <PostHogProvider apiKey={apiKey} options={options}>
        <App />
      </PostHogProvider>
    </main>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
